import { render, staticRenderFns } from "./editSend.vue?vue&type=template&id=3350020f&scoped=true&"
import script from "./editSend.vue?vue&type=script&lang=js&"
export * from "./editSend.vue?vue&type=script&lang=js&"
import style0 from "./editSend.vue?vue&type=style&index=0&id=3350020f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3350020f",
  null
  
)

export default component.exports